import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateContractPriceList } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractPriceListUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateContractPriceList,
        onSuccess: (_, { contractId }) =>
            queryClient.invalidateQueries({ queryKey: queries.contracts.detail(contractId).queryKey }),
    });
};
